import { useEffect, useState, useRef } from "react";
import API from "../api";


function Events() {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  // Planning semestriel
const [showPlanning, setShowPlanning] = useState(false);
const [planningPdfUrl, setPlanningPdfUrl] = useState(null);
const [planningPdfLoading, setPlanningPdfLoading] = useState(false);
const [planningPdfUploading, setPlanningPdfUploading] = useState(false);

  // Formulaire ajout réunion
  const [showAddForm, setShowAddForm] = useState(false);

  const emptyForm = {
    title: "",
    event_date: "",
    event_time: "",
    location: "",
    grade: "apprenti",
    agenda: "",
  };

  const [form, setForm] = useState(emptyForm);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchPlanningPdf = async () => {
  try {
    setPlanningPdfLoading(true);

    const res = await API.get(
      "/planning-semestriel",
      {
        responseType: "blob",
      }
    );

    const url = URL.createObjectURL(res.data);

    setPlanningPdfUrl((oldUrl) => {
      if (oldUrl) {
        URL.revokeObjectURL(oldUrl);
      }

      return url;
    });
  } catch (err) {
    if (err.response?.status === 404) {
      setPlanningPdfUrl(null);
    } else {
      console.error(
        "Erreur planning semestriel:",
        err
      );
    }
  } finally {
    setPlanningPdfLoading(false);
  }
};

const uploadPlanningPdf = async (event) => {
  const file = event.target.files?.[0];

  if (!file) return;

  if (file.type !== "application/pdf") {
    alert("Seuls les fichiers PDF sont autorisés.");
    event.target.value = "";
    return;
  }

  if (
    !window.confirm(
      "Remplacer le planning semestriel actuel ?"
    )
  ) {
    event.target.value = "";
    return;
  }

  try {
    setPlanningPdfUploading(true);

    const formData = new FormData();
    formData.append("pdf", file);

    await API.post(
      "/planning-semestriel",
      formData
    );

    await fetchPlanningPdf();

    alert("Planning semestriel mis à jour.");
  } catch (err) {
    console.error(
      "Erreur upload planning:",
      err
    );

    alert(
      err.response?.data?.message ||
      "Impossible de mettre à jour le planning."
    );
  } finally {
    setPlanningPdfUploading(false);
    event.target.value = "";
  }
};

  const fetchEvents = async () => {
    try {
      const res = await API.get("/events");
      setEvents(res.data);
    } catch (err) {
      console.error("Erreur events:", err);
      alert("Impossible de charger les réunions");
    }
  };

  const fetchParticipants = async (eventId) => {
    if (!isAdmin) return;

    try {
      const res = await API.get(`/events/${eventId}/participants`);
      setParticipants(res.data);
    } catch (err) {
      console.error("Erreur participants:", err);
    }
  };

  const createEvent = async () => {
    if (!form.title || !form.event_date || !form.event_time || !form.location) {
      alert("Merci de remplir le titre, la date, l'heure et le lieu");
      return;
    }

    try {
      setLoading(true);

      await API.post("/events", {
        ...form,
        allow_attendance: true,
        allow_agapes: true,
      });

      setForm(emptyForm);
      setShowAddForm(false);

      await fetchEvents();

      alert("Réunion ajoutée");
    } catch (err) {
      console.error("Erreur création réunion:", err);
      alert("Impossible d'ajouter la réunion");
    } finally {
      setLoading(false);
    }
  };

  const openEvent = async (event) => {
    setSelectedEvent(event);
    setEditMode(false);

    setForm({
      title: event.title || "",
      event_date: event.event_date ? event.event_date.slice(0, 10) : "",
      event_time: event.event_time ? event.event_time.slice(0, 5) : "",
      location: event.location || "",
      grade: event.grade || "apprenti",
      agenda: event.agenda || "",
    });

    await fetchParticipants(event.id);
  };

  const updateRegistration = async (type, value) => {
  try {
    const payload = {
      [type]: value,
    };

    await API.post(
      `/events/${selectedEvent.id}/register`,
      payload
    );

    const updated = {
      ...selectedEvent,
      [type]: value ? 1 : 0,
    };

    setSelectedEvent(updated);

    setEvents((prev) =>
      prev.map((e) =>
        e.id === updated.id ? updated : e
      )
    );

    await fetchParticipants(selectedEvent.id);

  } catch (err) {
    console.error("Erreur inscription:", err);
    alert("Impossible de mettre à jour la réponse");
  }
};

  const updateEvent = async () => {
    if (!form.title || !form.event_date || !form.event_time || !form.location) {
      alert("Merci de remplir le titre, la date, l'heure et le lieu");
      return;
    }

    try {
      await API.put(`/events/${selectedEvent.id}`, form);

      const updated = {
        ...selectedEvent,
        ...form,
      };

      setSelectedEvent(updated);
      setEditMode(false);
      await fetchEvents();

      alert("Réunion modifiée");
    } catch (err) {
      console.error("Erreur modification réunion:", err);
      alert("Impossible de modifier la réunion");
    }
  };

  const deleteEvent = async () => {
    if (!window.confirm("Supprimer cette réunion ?")) return;

    try {
      await API.delete(`/events/${selectedEvent.id}`);
      setSelectedEvent(null);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur suppression réunion:", err);
      alert("Impossible de supprimer la réunion");
    }
  };

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatShortDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (time) => {
    if (!time) return "";
    return time.slice(0, 5);
  };

  const gradeLabel = {
    apprenti: "Membre niveau 1",
    compagnon: "Membre niveau 2",
    maitre: "Membre niveau 3",
  };

  const countTenue = participants.filter((p) => p.attending).length;
  const countAgapes = participants.filter((p) => p.agapes).length;

  const updateForm = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /*
   * Construction du planning semestriel
   *
   * On prend les réunions existantes et on les regroupe
   * par mois.
   */
  const planningEvents = [...events].sort(
    (a, b) => new Date(a.event_date) - new Date(b.event_date)
  );

  const groupedPlanning = planningEvents.reduce((groups, event) => {
    const date = new Date(event.event_date);

    const monthKey = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}`;

    if (!groups[monthKey]) {
      groups[monthKey] = {
        year: date.getFullYear(),
        month: date.getMonth(),
        events: [],
      };
    }

    groups[monthKey].events.push(event);

    return groups;
  }, {});

  const planningMonths = Object.values(groupedPlanning).sort(
    (a, b) =>
      new Date(a.year, a.month, 1) -
      new Date(b.year, b.month, 1)
  );

  const formatMonth = (month, year) => {
    return new Date(year, month, 1).toLocaleDateString("fr-FR", {
      month: "long",
      year: "numeric",
    });
  };

  /*
   * Détail d'une réunion
   */
  if (selectedEvent) {
    const attending = selectedEvent.attending;
    const agapes = selectedEvent.agapes;

    return (
      <div style={styles.page}>
        <button
          style={styles.backButton}
          onClick={() => setSelectedEvent(null)}
        >
          ← Retour
        </button>

        {!editMode ? (
          <div style={styles.detailCard}>
            <div style={styles.badge}>
              {gradeLabel[selectedEvent.grade]}
            </div>

            <h1 style={styles.detailTitle}>
              {selectedEvent.title}
            </h1>

            <div style={styles.infoBox}>
              <p style={styles.info}>
                📅 {formatDate(selectedEvent.event_date)}
              </p>

              <p style={styles.info}>
                🕒 {formatTime(selectedEvent.event_time)}
              </p>

              <p style={styles.info}>
                📍 {selectedEvent.location}
              </p>
            </div>

            <div style={styles.agendaBox}>
              <h2 style={styles.sectionTitle}>
                Ordre du jour
              </h2>

              <p style={styles.agendaText}>
                {selectedEvent.agenda ||
                  "Aucun ordre du jour renseigné."}
              </p>
            </div>

            <div style={styles.actions}>

  {/* ============================= */}
  {/* RÉUNION */}
  {/* ============================= */}

  <div style={styles.responseBox}>
    <h3 style={styles.responseTitle}>
      🕯️ Participation à la réunion
    </h3>

    {attending === null || attending === undefined ? (
      <p style={styles.responseStatus}>
        Vous n'avez pas encore répondu.
      </p>
    ) : attending === 1 ? (
      <p style={styles.responseYes}>
        ✓ Vous participez à la réunion
      </p>
    ) : (
      <p style={styles.responseNo}>
        ✕ Vous ne participez pas à la réunion
      </p>
    )}

    <div style={styles.responseButtons}>
      <button
        style={
          attending === 1
            ? styles.activeButton
            : styles.yesButton
        }
        onClick={() =>
          updateRegistration("attending", true)
        }
      >
        ✓ Je participe
      </button>

      <button
        style={
          attending === 0
            ? styles.noButtonActive
            : styles.noButton
        }
        onClick={() =>
          updateRegistration("attending", false)
        }
      >
        ✕ Je ne participe pas
      </button>
    </div>
  </div>


  {/* ============================= */}
  {/* REPAS */}
  {/* ============================= */}

  <div style={styles.responseBox}>
    <h3 style={styles.responseTitle}>
      🍽️ Participation au repas
    </h3>

    {agapes === null || agapes === undefined ? (
      <p style={styles.responseStatus}>
        Vous n'avez pas encore répondu.
      </p>
    ) : agapes === 1 ? (
      <p style={styles.responseYes}>
        ✓ Vous participez au repas
      </p>
    ) : (
      <p style={styles.responseNo}>
        ✕ Vous ne participez pas au repas
      </p>
    )}

    <div style={styles.responseButtons}>
      <button
        style={
          agapes === 1
            ? styles.activeButton
            : styles.yesButton
        }
        onClick={() =>
          updateRegistration("agapes", true)
        }
      >
        ✓ Je participe
      </button>

      <button
        style={
          agapes === 0
            ? styles.noButtonActive
            : styles.noButton
        }
        onClick={() =>
          updateRegistration("agapes", false)
        }
      >
        ✕ Je ne participe pas
      </button>
    </div>
  </div>

</div>

            {isAdmin && (
              <div style={styles.adminBox}>
                <h2 style={styles.sectionTitle}>
                  Participants
                </h2>

                <div style={styles.counterRow}>
                  <div style={styles.counter}>
                    <strong>{countTenue}</strong>
                    <span>Réunion</span>
                  </div>

                  <div style={styles.counter}>
                    <strong>{countAgapes}</strong>
                    <span>Repas</span>
                  </div>
                </div>

                {participants.length === 0 ? (
                  <p style={styles.empty}>
                    Aucun inscrit pour le moment.
                  </p>
                ) : (
                  participants.map((p) => (
                    <div
                      key={p.id}
                      style={styles.participant}
                    >
                      <span>
                        {p.firstname} {p.lastname}
                      </span>

                      <span>
                        {p.attending
                          ? "Réunion ✓"
                          : "Réunion —"}{" "}
                        /{" "}
                        {p.agapes
                          ? "Repas ✓"
                          : "Repas —"}
                      </span>
                    </div>
                  ))
                )}

                <button
                  style={styles.goldButton}
                  onClick={() => setEditMode(true)}
                >
                  Modifier la réunion
                </button>

                <button
                  style={styles.deleteButton}
                  onClick={deleteEvent}
                >
                  Supprimer la réunion
                </button>
              </div>
            )}
          </div>
        ) : (
          <div style={styles.formCard}>
            <h1 style={styles.detailTitle}>
              Modifier la réunion
            </h1>

            <input
              style={styles.input}
              placeholder="Titre"
              value={form.title}
              onChange={(e) =>
                updateForm("title", e.target.value)
              }
            />

            <input
              style={styles.input}
              type="date"
              value={form.event_date}
              onChange={(e) =>
                updateForm("event_date", e.target.value)
              }
            />

            <input
              style={styles.input}
              type="time"
              value={form.event_time}
              onChange={(e) =>
                updateForm("event_time", e.target.value)
              }
            />

            <input
              style={styles.input}
              placeholder="Lieu"
              value={form.location}
              onChange={(e) =>
                updateForm("location", e.target.value)
              }
            />

            <select
              style={styles.input}
              value={form.grade}
              onChange={(e) =>
                updateForm("grade", e.target.value)
              }
            >
              <option value="apprenti">
                Membre niveau 1
              </option>

              <option value="compagnon">
                Membre niveau 2
              </option>

              <option value="maitre">
                Membre niveau 3
              </option>
            </select>

            <textarea
              style={styles.textarea}
              placeholder="Ordre du jour"
              value={form.agenda}
              onChange={(e) =>
                updateForm("agenda", e.target.value)
              }
            />

            <button
              style={styles.goldButton}
              onClick={updateEvent}
            >
              Enregistrer
            </button>

            <button
              style={styles.secondaryButton}
              onClick={() => setEditMode(false)}
            >
              Annuler
            </button>
          </div>
        )}
      </div>
    );
  }

  /*
   * Page principale
   */
  return (
    <div style={styles.page}>
      <h1 style={styles.title}>
        Agenda des réunions
      </h1>

      {/* ============================= */}
      {/* PLANNING SEMESTRIEL */}
      {/* ============================= */}

      <button
  style={styles.planningButton}
  onClick={async () => {
    setShowPlanning(true);
    await fetchPlanningPdf();
  }}
>
  📅 Planning semestriel
</button>

      {/* ============================= */}
      {/* RÉUNIONS PROGRAMMÉES */}
      {/* ============================= */}

      <h2 style={styles.listTitle}>
        Réunions programmées
      </h2>

      <div style={styles.list}>
        {events.length === 0 ? (
          <p style={styles.empty}>
            Aucune réunion prévue.
          </p>
        ) : (
          events.map((event) => (
            <div
              key={event.id}
              style={styles.card}
              onClick={() => openEvent(event)}
            >
              <div style={styles.cardTop}>
                <span style={styles.badge}>
                  {gradeLabel[event.grade]}
                </span>

                <span style={styles.date}>
                  {formatDate(event.event_date)}
                </span>
              </div>

              <h2 style={styles.cardTitle}>
                {event.title}
              </h2>

              <p style={styles.info}>
                🕒 {formatTime(event.event_time)}
              </p>

              <p style={styles.info}>
                📍 {event.location}
              </p>

              <div style={styles.statusRow}>
                <span
                  style={
                    event.attending
                      ? styles.statusOn
                      : styles.statusOff
                  }
                >
                  {event.attending
                    ? "Réunion ✓"
                    : "Réunion —"}
                </span>

                <span
                  style={
                    event.agapes
                      ? styles.statusOn
                      : styles.statusOff
                  }
                >
                  {event.agapes
                    ? "Repas ✓"
                    : "Repas —"}
                </span>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ============================= */}
      {/* AJOUT RÉUNION ADMIN */}
      {/* ============================= */}

      {isAdmin && (
        <div style={styles.addSection}>
          {!showAddForm ? (
            <button
              style={styles.addButton}
              onClick={() => setShowAddForm(true)}
            >
              ＋ Ajouter une réunion
            </button>
          ) : (
            <div style={styles.formCard}>
              <div style={styles.formHeader}>
                <h2 style={styles.formTitle}>
                  Ajouter une réunion
                </h2>

                <button
                  style={styles.closeFormButton}
                  onClick={() => {
                    setShowAddForm(false);
                    setForm(emptyForm);
                  }}
                >
                  ✕
                </button>
              </div>

              <input
                style={styles.input}
                placeholder="Titre de la réunion"
                value={form.title}
                onChange={(e) =>
                  updateForm("title", e.target.value)
                }
              />

              <input
                style={styles.input}
                type="date"
                value={form.event_date}
                onChange={(e) =>
                  updateForm("event_date", e.target.value)
                }
              />

              <input
                style={styles.input}
                type="time"
                value={form.event_time}
                onChange={(e) =>
                  updateForm("event_time", e.target.value)
                }
              />

              <input
                style={styles.input}
                placeholder="Lieu"
                value={form.location}
                onChange={(e) =>
                  updateForm("location", e.target.value)
                }
              />

              <select
                style={styles.input}
                value={form.grade}
                onChange={(e) =>
                  updateForm("grade", e.target.value)
                }
              >
                <option value="apprenti">
                  Membre niveau 1
                </option>

                <option value="compagnon">
                  Membre niveau 2
                </option>

                <option value="maitre">
                  Membre niveau 3
                </option>
              </select>

              <textarea
                style={styles.textarea}
                placeholder="Ordre du jour"
                value={form.agenda}
                onChange={(e) =>
                  updateForm("agenda", e.target.value)
                }
              />

              <button
                style={styles.goldButton}
                onClick={createEvent}
                disabled={loading}
              >
                {loading
                  ? "Ajout..."
                  : "Ajouter la réunion"}
              </button>
            </div>
          )}
        </div>
      )}

      {/* ============================= */}
      {/* POPUP PLANNING */}
      {/* ============================= */}

      {showPlanning && (
        <div
          style={styles.modalOverlay}
          onClick={() => setShowPlanning(false)}
        >
          <div
            style={styles.modal}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                📅 Planning semestriel
              </h2>

              <button
                style={styles.modalClose}
                onClick={() => setShowPlanning(false)}
              >
                ✕
              </button>
            </div>

            <div style={styles.modalContent}>
            {/* ============================= */}
{/* PLANNING PDF OFFICIEL */}
{/* ============================= */}

<div style={styles.officialPlanningBox}>
  <h3 style={styles.officialPlanningTitle}>
    📄 Planning officiel
  </h3>

  {planningPdfLoading ? (
    <p style={styles.empty}>
      Chargement du planning...
    </p>
  ) : planningPdfUrl ? (
    <>
      <button
  style={styles.openPlanningButton}
  onClick={() => {
    window.open(planningPdfUrl, "_blank");
  }}
>
  📄 Ouvrir le planning officiel
</button>

      {isAdmin && (
        <label style={styles.replacePlanningButton}>
          {planningPdfUploading
            ? "Remplacement..."
            : "🔄 Remplacer le PDF"}

          <input
            type="file"
            accept="application/pdf"
            onChange={uploadPlanningPdf}
            disabled={planningPdfUploading}
            style={{ display: "none" }}
          />
        </label>
      )}
    </>
  ) : (
    <>
      <p style={styles.empty}>
        Aucun planning officiel disponible.
      </p>

      {isAdmin && (
        <label style={styles.uploadPlanningButton}>
          📤 Déposer le planning PDF

          <input
            type="file"
            accept="application/pdf"
            onChange={uploadPlanningPdf}
            disabled={planningPdfUploading}
            style={{ display: "none" }}
          />
        </label>
      )}
    </>
  )}
</div>

{/* ============================= */}
{/* RÉUNIONS ENREGISTRÉES */}
{/* ============================= */}

<h3 style={styles.dynamicPlanningTitle}>
  📅 Réunions programmées
</h3>
              {planningMonths.length === 0 ? (
                <p style={styles.empty}>
                  Aucune réunion programmée.
                </p>
              ) : (
                planningMonths.map((month) => (
                  <div
                    key={`${month.year}-${month.month}`}
                    style={styles.monthBlock}
                  >
                    <h3 style={styles.monthTitle}>
                      {formatMonth(
                        month.month,
                        month.year
                      )}
                    </h3>

                    {month.events.map((event) => (
                      <div
                        key={event.id}
                        style={styles.planningEvent}
                        onClick={() => {
                          setShowPlanning(false);
                          openEvent(event);
                        }}
                      >
                        <div style={styles.planningDate}>
                          {formatShortDate(
                            event.event_date
                          )}
                        </div>

                        <div style={styles.planningInfo}>
                          <strong>
                            {event.title}
                          </strong>

                          <span>
                            {formatTime(
                              event.event_time
                            )}{" "}
                            • {event.location}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    padding: "24px",
    paddingBottom: "115px",
    background:
      "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
    color: "#2F2A3A",
  },

  title: {
    margin: "0 0 22px 0",
    fontSize: "30px",
    color: "#9AB86A",
  },

  listTitle: {
    margin: "28px 0 16px 0",
    fontSize: "22px",
    color: "#7E9E52",
  },

  planningPdfViewer: {
  width: "100%",
  maxHeight: "55vh",
  overflowY: "auto",
  overflowX: "hidden",
  padding: "8px",
  background: "#eeeeee",
  borderRadius: "14px",
  boxSizing: "border-box",
},
  officialPlanningBox: {
  marginBottom: "24px",
  padding: "16px",
  borderRadius: "18px",
  background: "rgba(255,255,255,0.70)",
  border: "1px solid rgba(143,174,93,0.20)",
},

officialPlanningTitle: {
  margin: "0 0 14px 0",
  fontSize: "19px",
  color: "#7E9E52",
},

planningPdf: {
  width: "100%",
  height: "500px",
  border: "none",
  borderRadius: "12px",
  background: "#ffffff",
},

uploadPlanningButton: {
  display: "block",
  width: "100%",
  padding: "14px",
  boxSizing: "border-box",
  textAlign: "center",
  borderRadius: "14px",
  background:
    "linear-gradient(135deg, #8FAE5D, #9AB86A)",
  color: "#ffffff",
  fontSize: "16px",
  fontWeight: "800",
  cursor: "pointer",
},

replacePlanningButton: {
  display: "block",
  width: "100%",
  marginTop: "12px",
  padding: "13px",
  boxSizing: "border-box",
  textAlign: "center",
  borderRadius: "14px",
  background: "rgba(143,174,93,0.12)",
  border:
    "1px solid rgba(143,174,93,0.25)",
  color: "#7E9E52",
  fontSize: "15px",
  fontWeight: "800",
  cursor: "pointer",
},

dynamicPlanningTitle: {
  margin: "10px 0 16px 0",
  fontSize: "19px",
  color: "#7E9E52",
},
  planningButton: {
    width: "100%",
    padding: "17px",
    borderRadius: "20px",
    border: "1px solid rgba(143,174,93,0.25)",
    background:
      "linear-gradient(135deg, rgba(143,174,93,0.18), rgba(154,184,106,0.12))",
    color: "#7E9E52",
    fontSize: "18px",
    fontWeight: "800",
    boxShadow:
      "0 8px 20px rgba(110,143,183,0.10)",
  },

  addSection: {
    marginTop: "24px",
  },

  addButton: {
    width: "100%",
    padding: "17px",
    borderRadius: "20px",
    border: "1px solid rgba(143,174,93,0.25)",
    background: "rgba(255,255,255,0.85)",
    color: "#7E9E52",
    fontSize: "17px",
    fontWeight: "800",
  },

  formCard: {
    background: "rgba(255,255,255,0.85)",
    border:
      "1px solid rgba(143,174,93,0.20)",
    borderRadius: "24px",
    padding: "18px",
    marginBottom: "24px",
    backdropFilter: "blur(10px)",
  },

  formHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "14px",
  },

  formTitle: {
    margin: 0,
    color: "#9AB86A",
  },

  closeFormButton: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    border: "none",
    background: "rgba(123,111,143,0.12)",
    color: "#7B6F8F",
    fontSize: "16px",
    fontWeight: "800",
  },

  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "12px",
    borderRadius: "16px",
    border:
      "1px solid rgba(143,174,93,0.20)",
    background: "rgba(255,255,255,0.85)",
    color: "#3B3450",
    fontSize: "16px",
    boxSizing: "border-box",
  },

  textarea: {
    width: "100%",
    minHeight: "130px",
    padding: "14px",
    marginBottom: "14px",
    borderRadius: "16px",
    border:
      "1px solid rgba(143,174,93,0.20)",
    background: "rgba(255,255,255,0.85)",
    color: "#3B3450",
    fontSize: "16px",
    lineHeight: "1.5",
    boxSizing: "border-box",
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  card: {
    background: "rgba(255,255,255,0.85)",
    border:
      "1px solid rgba(143,174,93,0.20)",
    backdropFilter: "blur(10px)",
    borderRadius: "24px",
    padding: "18px",
    boxShadow:
      "0 8px 20px rgba(110,143,183,0.12)",
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
  },

  badge: {
    display: "inline-block",
    background:
      "rgba(143,174,93,0.12)",
    border:
      "1px solid rgba(143,174,93,0.25)",
    color: "#9AB86A",
    borderRadius: "999px",
    padding: "6px 12px",
    fontSize: "13px",
    fontWeight: "700",
  },

  date: {
    color: "#6E8FB7",
    fontSize: "13px",
    textAlign: "right",
  },

  cardTitle: {
    margin: "0 0 12px 0",
    fontSize: "22px",
    color: "#3B3450",
  },

  info: {
    margin: "8px 0",
    color: "#6E8FB7",
    fontSize: "16px",
    lineHeight: "1.4",
  },

  statusRow: {
    display: "flex",
    gap: "10px",
    marginTop: "14px",
  },

  statusOn: {
    flex: 1,
    textAlign: "center",
    background:
      "rgba(77, 180, 105, 0.18)",
    color: "#4D8F5B",
    border:
      "1px solid rgba(77, 180, 105, 0.4)",
    borderRadius: "14px",
    padding: "9px",
    fontSize: "13px",
    fontWeight: "700",
  },

  statusOff: {
    flex: 1,
    textAlign: "center",
    background:
      "rgba(255,255,255,0.06)",
    color: "#7B6F8F",
    border:
      "1px solid rgba(255,255,255,0.12)",
    borderRadius: "14px",
    padding: "9px",
    fontSize: "13px",
    fontWeight: "700",
  },

  backButton: {
    width: "100%",
    padding: "14px",
    marginBottom: "22px",
    borderRadius: "16px",
    border: "none",
    background:
      "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#ffffff",
    fontSize: "17px",
    fontWeight: "800",
  },

  detailCard: {
    background: "rgba(255,255,255,0.85)",
    border:
      "1px solid rgba(143,174,93,0.20)",
    backdropFilter: "blur(10px)",
    borderRadius: "26px",
    padding: "20px",
  },

  detailTitle: {
    margin: "16px 0 16px 0",
    fontSize: "30px",
    color: "#3B3450",
  },

  infoBox: {
    background:
      "rgba(143,174,93,0.08)",
    borderRadius: "18px",
    padding: "12px 14px",
    marginBottom: "18px",
  },

  agendaBox: {
    marginTop: "18px",
    paddingTop: "18px",
    borderTop:
      "1px solid rgba(255,255,255,0.12)",
  },

  sectionTitle: {
    margin: "0 0 12px 0",
    color: "#7E9E52",
    fontSize: "21px",
  },

  agendaText: {
    whiteSpace: "pre-wrap",
    lineHeight: "1.65",
    fontSize: "17px",
    color: "#3B3450",
    margin: 0,
  },

  actions: {
    marginTop: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  
  responseBox: {
  background: "rgba(143,174,93,0.07)",
  border: "1px solid rgba(143,174,93,0.18)",
  borderRadius: "18px",
  padding: "16px",
},

responseTitle: {
  margin: "0 0 8px 0",
  color: "#7E9E52",
  fontSize: "18px",
},

responseStatus: {
  margin: "0 0 14px 0",
  color: "#7B6F8F",
  fontSize: "14px",
},

responseYes: {
  margin: "0 0 14px 0",
  color: "#4D8F5B",
  fontSize: "14px",
  fontWeight: "700",
},

responseNo: {
  margin: "0 0 14px 0",
  color: "#C85C5C",
  fontSize: "14px",
  fontWeight: "700",
},

responseButtons: {
  display: "flex",
  gap: "10px",
},

yesButton: {
  flex: 1,
  padding: "12px 8px",
  borderRadius: "14px",
  border: "1px solid rgba(77,180,105,0.35)",
  background: "rgba(77,180,105,0.10)",
  color: "#4D8F5B",
  fontSize: "14px",
  fontWeight: "800",
},

noButton: {
  flex: 1,
  padding: "12px 8px",
  borderRadius: "14px",
  border: "1px solid rgba(200,92,92,0.25)",
  background: "rgba(200,92,92,0.08)",
  color: "#C85C5C",
  fontSize: "14px",
  fontWeight: "800",
},

noButtonActive: {
  flex: 1,
  padding: "12px 8px",
  borderRadius: "14px",
  border: "1px solid rgba(200,92,92,0.45)",
  background: "rgba(200,92,92,0.18)",
  color: "#C85C5C",
  fontSize: "14px",
  fontWeight: "800",
},

  goldButton: {
    width: "100%",
    padding: "15px",
    borderRadius: "16px",
    border: "none",
    background:
      "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#ffffff",
    fontSize: "17px",
    fontWeight: "800",
  },

  activeButton: {
    width: "100%",
    padding: "15px",
    borderRadius: "16px",
    border:
      "1px solid rgba(77, 180, 105, 0.45)",
    background:
      "rgba(77, 180, 105, 0.22)",
    color: "#4D8F5B",
    fontSize: "17px",
    fontWeight: "800",
  },

  secondaryButton: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    borderRadius: "16px",
    background:
      "rgba(255,255,255,0.75)",
    border:
      "1px solid rgba(143,174,93,0.20)",
    color: "#3B3450",
    fontSize: "16px",
    fontWeight: "700",
  },

  deleteButton: {
    width: "100%",
    padding: "14px",
    marginTop: "12px",
    borderRadius: "16px",
    border:
      "1px solid rgba(255,90,90,0.35)",
    background:
      "rgba(255,90,90,0.14)",
    color: "#c85c5c",
    fontSize: "16px",
    fontWeight: "800",
  },

  adminBox: {
    marginTop: "24px",
    paddingTop: "18px",
    borderTop:
      "1px solid rgba(255,255,255,0.12)",
  },

  counterRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "16px",
  },

  counter: {
    flex: 1,
    background:
      "rgba(143,174,93,0.08)",
    borderRadius: "18px",
    padding: "14px",
    textAlign: "center",
    border:
      "1px solid rgba(143,174,93,0.18)",
  },

  participant: {
    background:
      "rgba(255,255,255,0.65)",
    borderRadius: "14px",
    padding: "12px",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    color: "#3B3450",
  },

  empty: {
    color: "#7B6F8F",
    textAlign: "center",
    marginTop: "20px",
  },

  /* ============================= */
  /* MODAL PLANNING */
  /* ============================= */

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(47,42,58,0.55)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    zIndex: 9999,
  },

  modal: {
    width: "100%",
    maxWidth: "600px",
    maxHeight: "85vh",
    background:
      "linear-gradient(180deg, #F8F5FC 0%, #EDE5F6 100%)",
    borderRadius: "28px",
    boxShadow:
      "0 20px 60px rgba(47,42,58,0.30)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 20px",
    borderBottom:
      "1px solid rgba(143,174,93,0.18)",
  },

  modalTitle: {
    margin: 0,
    color: "#7E9E52",
    fontSize: "22px",
  },

  modalClose: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: "none",
    background:
      "rgba(123,111,143,0.12)",
    color: "#7B6F8F",
    fontSize: "17px",
    fontWeight: "800",
  },

  modalContent: {
    overflowY: "auto",
    padding: "20px",
  },

  monthBlock: {
    marginBottom: "22px",
  },

  monthTitle: {
    margin: "0 0 10px 0",
    textTransform: "capitalize",
    color: "#9AB86A",
    fontSize: "20px",
    borderBottom:
      "1px solid rgba(143,174,93,0.18)",
    paddingBottom: "8px",
  },

  planningEvent: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    background:
      "rgba(255,255,255,0.78)",
    borderRadius: "16px",
    padding: "12px",
    marginBottom: "8px",
    border:
      "1px solid rgba(143,174,93,0.12)",
  },

  planningDate: {
    minWidth: "70px",
    fontWeight: "800",
    color: "#6E8FB7",
    fontSize: "14px",
  },

  planningInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "3px",
    color: "#3B3450",
    fontSize: "15px",
  },
};

export default Events;